module.exports = __webpack_public_path__ + "static/media/OBE_hero-min.7e85cf81.png";